/** @jsx h */
import { h } from 'preact'

const ThumbsDownIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      fill='none'
      viewBox='0 0 24 24'
      aria-label='No'
    >
      <path
        stroke='currentColor'
        fill='white'
        d='M19.5 3.95251C18.6288 3.3451 17.5803 3.01216 16.5008 3.00001H7.25335C6.28935 2.99694 5.50511 3.7388 5.50173 4.65719C5.50005 5.11892 5.69996 5.56057 6.05368 5.87633C5.09909 5.97459 4.40881 6.79145 4.51196 7.70082C4.55676 8.09581 4.74913 8.46228 5.05392 8.73344C4.09919 8.83063 3.40793 9.64674 3.50999 10.5562C3.57265 11.1146 3.92805 11.6048 4.45408 11.8582C3.51599 12.4132 3.22784 13.5875 3.81043 14.4812C4.17422 15.0392 4.81422 15.3793 5.50379 15.381H12.5019C12.2273 16.2143 11.9774 18.3186 11.8636 19.7857C11.8614 20.9762 13.1268 23 14.0015 23C14.541 22.9925 15.0648 22.8262 15.5011 22.5238C15.2579 20.6984 15.2579 19.5873 15.5011 19.1905C15.8658 18.5952 18.2278 13.3572 18.5003 13.0001C18.6819 12.762 19.0152 12.6032 19.5 12.5239V3.95251Z'
      />
    </svg>
  )
}

export default ThumbsDownIcon
